import { FC, ReactNode, useCallback, useMemo } from "react"
import { IconButton, IconButtonProps, useTheme } from "@mui/material"
import { isFunction } from "lodash"

import { ShareIcon } from "components/icons"
import { getIcon } from "utils/icon"

interface IShareIconButton extends IconButtonProps {
  title?: string
  text?: string
  url?: string
  shareIcon?: ReactNode
}

export const ShareIconButton: FC<IShareIconButton> = ({
  title,
  text,
  url,
  onClick,
  shareIcon: shareIconProp = <ShareIcon />,
  ...props
}) => {
  const theme = useTheme()
  const shareIcon = useMemo(
    () => getIcon(theme?.assets?.shareIcon) || shareIconProp || <ShareIcon />,
    [theme, shareIconProp]
  )

  const isShareable = !!navigator.share
  const handleClick = useCallback(
    async (event) => {
      if (isFunction(onClick)) onClick(event)

      if (navigator.share) {
        try {
          await navigator.share({ title, text, url })
          alert("Share successful")
        } catch (err) {
          console.log("Error: ", err)
        }
      } else {
        console.log("Native Web Sharing not supported")
      }
    },
    [onClick, text, title, url]
  )
  return (
    isShareable && (
      <IconButton color="primary" onClick={handleClick} {...props}>
        {shareIcon}
      </IconButton>
    )
  )
}
